import type { ChatDeliveryRecoveryState } from "@/hooks/useLeaderChat";
import { Button } from "@/components/ui/button";

export function ChatDeliveryRecovery({ recovery }: { recovery?: ChatDeliveryRecoveryState }) {
  if (!recovery?.required) return null;
  return (
    <div role="status" aria-live="polite" className="mb-3 text-sm text-muted-foreground">
      <p>{recovery.reason === "history_unavailable" ? "Saved history could not be loaded. Check this conversation before sending. Sending stays paused until history can be confirmed." : "The response may already be saved. Check this conversation before sending again. If it cannot be confirmed yet, sending stays paused."}</p>
      <Button type="button" variant="link" className="h-auto px-0 pt-2" disabled={recovery.checking} onClick={() => void recovery.check()}>
        {recovery.checking ? "Checking saved conversation..." : "Check saved conversation"}
      </Button>
    </div>
  );
}
